// extracted by mini-css-extract-plugin
module.exports = {"Container":"Media_Container__Nej6T","Caption":"Media_Caption__u2k_z"};